// extracted by mini-css-extract-plugin
module.exports = {"side_bar":"AboutSubRedditCards_side_bar__1qOHa"};